import { Component, Input, OnInit } from "@angular/core";
import {
  FileSystemDirectoryEntry,
  FileSystemFileEntry,
  NgxFileDropEntry,
} from "ngx-file-drop";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import {
  ExperienceStepModel,
  GeneralExpWizardInfoByLang,
} from "src/app/models/experience-steps.model";
import { ErrorEmitterService } from "src/app/services/emitters/error-emitter.service";
import { ExperiencesService } from "src/app/services/experience/experiences.service";
import { FilesService } from "src/app/services/generic/files.service";
import { SavingEmitterService } from "src/app/services/emitters/saving-emitter.service";

@Component({
  selector: "app-images-step",
  templateUrl: "./images-step.component.html",
  styleUrls: ["./images-step.component.scss"],
})
export class ImagesStepComponent implements OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  @Input() step: ExperienceStepModel;
  @Input() generalInfoByLang: GeneralExpWizardInfoByLang;
  @Input() experienceId: string;
  @Input() hasIssue: boolean;
  @Input() comments: Array<any>;
  @Input() commentImmage: boolean;
  @Input() experienceOrigin: boolean;
  @Input() experienceOriginUrl: string;

  public galleryTypeError: boolean;
  public gallerySizeError: boolean;
  public galleryLengthError: boolean;
  public coverTypeError: boolean;
  public coverSizeError: boolean;
  public files: NgxFileDropEntry[] = [];
  public loadedImage: any;
  public loadedImageMulti: any;

  public selectImagePlaceHolder: string = "Select your image";

  constructor(
    private experienceSvc: ExperiencesService,
    private savingEmitter: SavingEmitterService,
    private errorEmitter: ErrorEmitterService,
    private filesSvc: FilesService
  ) {}

  ngOnInit(): void {
    this.checkStepComplete();

    this.generalInfoByLang.activeCoverImage = this.generalInfoByLang.selectedCoverImage;
  }

  fileChangeListener($event) {
    this.coverTypeError = false;
    this.coverSizeError = false;
    if ($event.target.files && $event.target.files[0]) {
      let fileSize = $event.target.files[0].size / 1024 / 1024;
      if (fileSize > 12) {
        this.coverSizeError = true;
        return false;
      }
      if (
        $event.target.files[0].type == "image/png" ||
        $event.target.files[0].type == "image/jpeg"
      ) {
        let reader = new FileReader();
        reader.onload = (event: any) => {
          this.loadedImage = event.target.result;
        };
        reader.readAsDataURL($event.target.files[0]);
      } else {
        this.coverTypeError = true;
        return false;
      }
    }
  }

  //get cover image from cropper
  coverImageGet($event) {
    this.generalInfoByLang.selectedCoverImage = $event;

    this.checkStepComplete();
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.gallerySizeError = false;
    this.galleryTypeError = false;
    this.galleryLengthError = false;
    this.files = files;

    if (this.generalInfoByLang.loadedImagesArray.length >= 6) {
      this.galleryLengthError = true;
      return false;
    }

    if (
      this.files.length + this.generalInfoByLang.loadedImagesArray.length >
      6
    ) {
      this.galleryLengthError = true;
      return false;
    } else {
      this.savingEmitter.sendMessage(true);
      for (const droppedFile of files) {
        let reader = new FileReader();

        // Is it a file?
        if (droppedFile.fileEntry.isFile) {
          const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
          fileEntry.file((file: File) => {
            // Here you can access the real file
            //console.log(droppedFile.relativePath, file);
            let fileSize = file.size / 1024 / 1024;
            if (fileSize > 12) {
              this.gallerySizeError = true;
              return false;
            }
            //Code for reading File
            if (file.type == "image/png" || file.type == "image/jpeg") {
              reader.readAsDataURL(file);
              reader.onload = () => {
                const formData = new FormData();
                formData.append("image", file);
                this.filesSvc
                  .fileUpload(formData)
                  .pipe(takeUntil(this.destroyed$))
                  .subscribe(
                    (x) => {
                      this.generalInfoByLang.loadedImagesArray.push({
                        original: reader.result,
                        id: x.result.resources[0].id,
                      });
                      this.experienceSvc
                        .addImageToGallery(
                          this.experienceId,
                          x.result.resources[0].id
                        )
                        .pipe(takeUntil(this.destroyed$))
                        .subscribe(
                          (x) => {
                            this.savingEmitter.sendMessage(false);
                          },
                          (err) => {
                            this.errorEmitter.sendError(true);
                          }
                        );
                    },
                    (err) => {
                      this.errorEmitter.sendError(true);
                    }
                  );

                this.loadedImageMulti = this.generalInfoByLang.loadedImagesArray[0];
              };
            } else {
              this.galleryTypeError = true;
              this.savingEmitter.sendMessage(false);
              return false;
            }
          });
        } else {
          // It was a directory (empty directories are added, otherwise only files)
          const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
          //console.log(droppedFile.relativePath, fileEntry);
        }
      }
    }
  }

  public removeImage(id, i) {
    this.savingEmitter.sendMessage(true);
    this.experienceSvc
      .removeImageFromGallery(this.experienceId, id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (x) => {
          this.generalInfoByLang.loadedImagesArray.splice(i, 1);
          this.savingEmitter.sendMessage(false);
        },
        (err) => {
          this.errorEmitter.sendError(true);
        }
      );
  }

  checkStepComplete() {
    if (this.generalInfoByLang.selectedCoverImage) {
      this.step.isComplete = true;
    } else {
      this.step.isComplete = false;
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
